import { DesktopNav } from './DesktopNav'
import { MobileNav } from './MobileNav'

export const Nav = () => {
  return (
    <>
      <DesktopNav />
      <MobileNav />
    </>
  )
}

export { DesktopNav } from './DesktopNav'
export { MobileNav } from './MobileNav'
